/**
 * Get the domain of a URL.
 * @param url The URL to get the domain of.
 * @returns The domain of the URL.
 */
export function getDomain(url: string): string {
  let domain = url?.replace(/^(https?:\/\/)?(www\.)?/, "") ?? "";

  domain = domain.split("/")?.[0] ?? "";
  domain = domain.replace(/:\d+$/, "");

  return domain;
}
